import React from 'react'
import If from '../operador/if'
import { InputPassword } from '../InputPassword';

import './style.css';

const renderField = ({ input, type, hide, placeholder, readOnly, meta: { error, submitFailed } }) => (
    <If test={!hide}>

        { !hide && type !== "password" &&
            <input {...input}
                className={"form-control " + (submitFailed && error ? "field-error" : "") }
                placeholder={placeholder}
                readOnly={readOnly}
                type={type}
                />
        }

        { type === "password" &&
            <InputPassword
                {...input}
                placeholder={placeholder}
                readOnly={readOnly}
            />
        }
        {submitFailed && (error && <span className={"error-label"}>{error}</span>)}

    </If>
  )

export default renderField
